<template lang="es">
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="12">
                        Administración de Departamentos
                    </v-col>
                    <!--<v-col cols="12" sm="12" md="6">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNuevo"
                        >
                            Crear nuevo
                        </v-btn>
                    </v-col> -->
            
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>

                <v-row>
                    <v-col cols="12" md="6" sm="6" xs="12">
                        <v-text-field
                            outlined
                            autocomplete="off"
                            dense
                            v-model="tableFilter"
                            label="Buscar"
                            maxlength="100"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-data-table
                        :headers="headers"
                        :items="deptos"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :items-per-page="10"
                        dense
                        :search="tableFilter"
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <!--<td>{{ item.id }}</td>-->
                            <td>{{ item.codigo }}</td>
                            <td>{{ item.nombreDepartamento }}</td>
                            <td>{{ item.nombreRegion }}</td>
                            
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
        <!-- Inicio:: Dialog para mostrar los datos de la etnia-->
    <v-dialog
        v-model="dialog"
        max-width="800px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col  md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosDepartamento.nombreDepartamento"
                                label="Nombre del departamento"
                                :rules="[
                                    required('Departamento'),
                                    minLength('Departamento', 5),
                                    alphaRule('Departamento')
                                ]"
                                maxlength="50"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col  md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosDepartamento.codigo"
                                label="Código del departamento"
                                :rules="[
                                    required('Código del departamento'),
                                    onlyInteger('Código')
                                ]"
                                maxlength="5"
                                v-mask="'#####'"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-autocomplete
                                        v-model="datosDepartamento.regionesId"
                                        :items="regiones"
                                        class="required"
                                        dense
                                        outlined
                                        :loading="dialogLoaderVisible"
                                        label="Región"
                                        item-text="nombreRegion"
                                        item-value="id"
                                        :rules="[
                                            selectRequired(
                                                'Región'
                                            )
                                        ]"
                                    ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos de la etnia-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->

    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_DEPARTAMENTOS, OBTENER_DEPARTAMENTO, REGISTRAR_DEPARTAMENTO, ACTUALIZAR_DEPARTAMENTO } from "@/core/services/store/catalogos/departamento.module";
import { OBTENER_REGIONES } from "@/core/services/store/region.module";
import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
export default {
    name: "AdminDeptos",
    components: {
    SnackAlert,
    DialogLoader
    },
        data() {
        return {
            validForm:false,
            itemName : "Departamentos",
            dialog: false,
            modalTitle: 'Registrar Departamento',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Departamento',
            accion: 1,
            deptos: [],
            regiones: [],
            switchItemEstado: true,
            datosDepartamento: {
                id: 0,
                nombreDepartamento: '',
                regionesId: 0,
                fechaCreacion: '2021-07-23', 
                usuarioCreacion: 'admin',
                fechaActualizacion: '2021-07-23', 
                usuarioActualizacion: '',
                estadosId: 1,
                codigo:'',
            },
            tableLoading: false,
            tableFilter:'',
            ...validations
        } 
    },
    methods: {
        modalNuevo(){
            this.accion =1;
            this.modalTitle='Registrar Departamento';
            this.btnRegistroText='Registrar Departamento';
            this.dialog=true;
        },

        resetForm(){
             this.datosDepartamento= {
                id: 0,
                nombreDepartamento: '',
                regionesId: 0,
                fechaCreacion: '2021-07-23', 
                usuarioCreacion: 'admin',
                fechaActualizacion: '2021-07-23', 
                usuarioActualizacion: '',
                estadosId: 1,
                codigo: '',
            };

            this.switchItemEstado = true;
        },

        //!Obtener los departamentos para la tabla
        obtnenerItems(){
            this.tableLoading = true;
            this.deptos=[];
            
            this.$store
                .dispatch(OBTENER_DEPARTAMENTOS)
                .then(res => {
                    if(res.status==200){
                        this.deptos = this.$store.state.departamento.departamentos;
                    }
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosDepartamento.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Departamento';
            this.btnRegistroText='Actualizar Departamento';

            this.$store
                .dispatch(OBTENER_DEPARTAMENTO, Id)
                .then(res => {
                    if(res.status===200){
                    // let item = this.$store.state.departamento.departamento;
                        this.datosDepartamento = this.$store.state.departamento.departamento;
                        this.datosDepartamento.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        // this.datosDepartamento.pais_Id = item.pais_Id
                        //console.log(this.datosEtnia)
                        this.dialog = true;
                    } else {
                         this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.dialogLoaderVisible = false;
                })
                .catch(() => {
                    this.dialogLoaderVisible = false;
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error, por favor, póngase en contacto con un administrador del sistema.');
                });
        },


        async obtenerRegiones(){
            this.regiones=[];
            
             this.$store
            .dispatch(OBTENER_REGIONES,0)
            .then(() => {
                this.regiones = this.$store.state.region.regiones;
                //console.log(this.departamentos)
            })
            .catch(() => {});
   
        },


        registrarItem(){
            //console.log(this.accion)
            
            this.btnRegistroLoading=true;

            this.switchItemEstado ? this.datosDepartamento.estadosId = 1 : this.datosDepartamento.estadosId = 2;

            if(this.accion===1){
                this.datosDepartamento.id = 0;
                this.$store
                    .dispatch(REGISTRAR_DEPARTAMENTO, this.datosDepartamento)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(() => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error, por favor, póngase en contacto con un administrador del sistema.');
                        this.btnRegistroLoading=false;
                    });

                        

            } else {
                this.$store
                    .dispatch(ACTUALIZAR_DEPARTAMENTO, this.datosDepartamento)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(() => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error, por favor, póngase en contacto con un administrador del sistema.');
                        this.btnRegistroLoading=false;
                    });

            }
        }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Catalogos" },
            { title: "Departamentos" }
        ]);
    },

    created(){
        this.obtnenerItems();
        this.obtenerRegiones();
    },

    computed: {
        headers() {
            return [
                /*{
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },*/
                 {
                    text: "Código",
                    value: "codigo"
                },
                {
                    text: "Nombre del departamento",
                    value: "nombreDepartamento"
                },
                {
                    text: "Nombre de la región",
                    value: "nombreRegion"
                },
                {
                    text: "Estado",
                    value: "estado"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }
}
</script>
<style lang="">
    
</style>